import { CardSection } from '~/service/api'

export class CustomCardSection extends CardSection {
  constructor(data: undefined | any = {}) {
    super()
    this.id = data.id || null
    this.card = data.card || null
    this.title = data.title || null
    this.sort_order = data.sort_order || null
  }
}
